import React, { useState } from 'react'
import { Box, Button, Grid2, TextField, Typography, Stack } from '@mui/material'
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { updateUser } from '../../apis/apiList/userApi';
import { useMessage } from '../../context/MessageContext';

const validationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email format").required("Email is required"),
  firstName: Yup.string().required("First Name is required"),
  lastName: Yup.string().required("Last Name is required"),
  // phone: Yup.string().required("Phone is required"),
  // password: Yup.string().min(3, "Password must be at least 3 characters").required("Password is required"),
  organization: Yup.string().required("Organization is required"),
});

function EditUser({ handleCancel, orgId, organization, user, handleUpdatedUser }) {
  const { showMessage } = useMessage();
  const [userInfo, setUserInfo]= useState(user?user:{});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    console.log('values', values)
    try {
      const formData = new FormData();
      console.log('userInfo', userInfo)

      formData.append("_id", userInfo._id);
      formData.append("orgId", orgId);
      formData.append("oldProfilePic", userInfo.profilePicture);
      formData.append("profile_pic", values.profile_pic);
      formData.append("folderid", organization.boxFolderId);

      // Append other values dynamically
      Object.keys(values).forEach((key) => {
        if (key !== "profile_pic") {
          formData.append(key, values[key]);
        }
      });
      // const data = {
      //   _id: userInfo._id,
      //   orgId: orgId,
      //   oldProfilePic: userInfo.profilePicture,
      //   profile_pic: values.profile_pic,
      //   folderid: organization.boxFolderId,
      //   ...values,
      // }
      const userData = await updateUser(formData, userInfo._id, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      handleUpdatedUser(userData.data)
      setIsSubmitting(false);
      showMessage('User update successfully', 'success');
    } catch (err) {
      console.log('err ', err)
      showMessage(err?.response?.data?.message || 'Something went wrong', 'error');
    }
  }

  const handleLinkedInLogin = () => {
    window.location.href = `${process.env.REACT_APP_BACKEND_URL}/api/v1/linkedin/auth`;
  };

  return (
    <Box>
      <Stack direction={'row'} justifyContent='space-between' mb={4}>
        <Typography variant='h3'  mt={2}>Edit User</Typography>
        <Button variant="contained" sx={{backgroundColor: '#0077b5'}} className='btn-linkedin' onClick={handleLinkedInLogin}>Connect With Linkedin</Button>
      </Stack>
      <Box>
        <Formik
          initialValues={{
            email: userInfo.email,
            firstName: userInfo.firstName,
            lastName: userInfo.lastName,
            phone: userInfo.phone,
            // password: userInfo.password,
            organization: userInfo.organization,
            jobTitle: userInfo.jobTitle,
            twitter: userInfo.twitter,
            linkedIn: userInfo.linkedin,
            profile_pic: null,
            notes: userInfo.notes,
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => {
            console.log("Form Data:", values);
            setSubmitting(false);
            setIsSubmitting(true)
            handleSubmit(values);
          }}
        >
          {({ values, setFieldValue, handleChange, handleBlur, errors, touched }) => (
            <Form>
              <Grid2 container spacing={2}>

                {/** First Name **/}
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="First Name"
                    name="firstName"
                    variant="outlined"
                    value={values.firstName}
                    onChange={handleChange}
                    error={touched.firstName && !!errors.firstName}
                    helperText={<ErrorMessage name="firstName" />}
                  />
                </Grid2>

                {/** Last Name **/}
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Last Name"
                    name="lastName"
                    variant="outlined"
                    value={values.lastName}
                    onChange={handleChange}
                    error={touched.lastName && !!errors.lastName}
                    helperText={<ErrorMessage name="lastName" />}
                  />
                </Grid2>

                <Grid2 size={{ xs: 12, md: 6 }}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Email"
                    name="email"
                    variant="outlined"
                    value={values.email}
                    disabled
                    onChange={handleChange}
                    error={touched.email && !!errors.email}
                    helperText={<ErrorMessage name="email" />}
                  />
                </Grid2>

                {/** Phone **/}
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Phone"
                    name="phone"
                    variant="outlined"
                    value={values.phone}
                    onChange={handleChange}
                    error={touched.phone && !!errors.phone}
                    helperText={<ErrorMessage name="phone" />}
                  />
                </Grid2>

                {/** Password **/}
                {/* <Grid2 size={{ xs: 12, md: 6 }}>
                  <Field
                    as={TextField}
                    fullWidth
                    type="password"
                    label="Password"
                    name="password"
                    variant="outlined"
                    value={values.password}
                    onChange={handleChange}
                    error={touched.password && !!errors.password}
                    helperText={<ErrorMessage name="password" />}
                  />
                </Grid2> */}

                {/** Organization **/}
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Organization"
                    name="organization"
                    variant="outlined"
                    value={values.organization}
                    disabled
                    onChange={handleChange}
                    error={touched.organization && !!errors.organization}
                    helperText={<ErrorMessage name="organization" />}
                  />
                </Grid2>

                {/** Job Title **/}
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Job Title"
                    name="jobTitle"
                    variant="outlined"
                    value={values.jobTitle}
                    onChange={handleChange}
                  />
                </Grid2>

                {/** Twitter **/}
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Twitter"
                    name="twitter"
                    variant="outlined"
                    value={values.twitter}
                    onChange={handleChange}
                  />
                </Grid2>

                {/** LinkedIn **/}
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="LinkedIn"
                    name="linkedIn"
                    variant="outlined"
                    value={values.linkedIn}
                    onChange={handleChange}
                  />
                </Grid2>

                {/** Notes **/}
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Notes"
                    name="notes"
                    variant="outlined"
                    value={values.notes}
                    onChange={handleChange}
                  />
                </Grid2>

                <Grid2 size={{ xs: 12, md: 6 }}>
                  <label htmlFor="profile_pic">Upload Profile Pic</label>
                  <input
                    type="file"
                    name="profile_pic"
                    className="form-control"
                    onChange={(event) => setFieldValue("profile_pic", event.currentTarget.files[0])}
                  />
                </Grid2>

              </Grid2>
              <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, justifyContent: 'start', mt: 4 }}>
                <Button variant='contained' type="submit" disabled={isSubmitting}>Update</Button>
                <Button variant='contained' onClick={() => { handleCancel() }}>Cancel</Button>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </Box>
  )
}

export default EditUser